import React from "react";
import { Navigate, Outlet } from "react-router-dom";

import { ROUTES } from "@/constants";
import { useIsLoggedIn } from "@/hooks";

const ProtectedRoute: React.FC = () => {
  const isLoggedIn = useIsLoggedIn();

  return isLoggedIn ? <Outlet /> : <Navigate to={ROUTES.LOGIN} />;
};

export default ProtectedRoute;
